module.exports = __webpack_public_path__ + "img/management.38fbecd3.jpg";